import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@monavate/ui-core';
import { Transaction } from '@/api/general';
import { useAppDispatch } from '@/reduxStore/rootReducer';
import { showLinkPaymentModal } from '@/reduxStore/slices/linkPaymentSlice';
import { closeTransactionModal } from '@/reduxStore/slices/transactionsSlice';

const LinkIcon = styled.span`
    font-size: 24px;
    font-weight: 300;
    color: ${(props) => props.theme['Content/primary']};
    cursor: pointer;
`;

interface LinkPaymentIconProps {
    transaction: Transaction;
    // the link blade replaces the transaction blade rather than stacking on top of it
    closesTransactionBlade?: boolean;
}

const LinkPaymentIcon: React.FC<LinkPaymentIconProps> = ({
    transaction,
    closesTransactionBlade,
}) => {
    const dispatch = useAppDispatch();

    const linkOnClickHandler = (event: React.MouseEvent<HTMLElement>) => {
        // the icon sits inside a clickable table row that opens the transaction blade
        event.stopPropagation();
        dispatch(showLinkPaymentModal(transaction));
        if (closesTransactionBlade) {
            dispatch(closeTransactionModal());
        }
    };

    return (
        <Tooltip title="Link payment instruction">
            <LinkIcon
                className="material-symbols-sharp"
                onClick={linkOnClickHandler}
                data-test-id="icon-link-payment"
            >
                link
            </LinkIcon>
        </Tooltip>
    );
};

export default LinkPaymentIcon;
